
import UserOctagon from "../../../assets/outline/UserOctagon.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserOctagonIcon({ className, dataTestid = "UserOctagonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UserOctagon data-testid={dataTestid} className={classes} {...rest} />
  );
}
